import { formatCurrency } from '@/lib/utils';

// Re-export as formatCurrencyValue for backward compatibility
export const formatCurrencyValue = (value: number) =>
  formatCurrency(value, { showNullAs: '' });
